import * as ACTION from '../containers/NotFound/actionTypes';

const initialState = {
  loading: false,
};


const notFoundReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.LOADING_PAGE_NOTFOUND:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default notFoundReducer;
